import React, { useState } from 'react';
import styled from 'styled-components';
import Modal from '../../components/Modal';
import PropTypes from 'prop-types';

function FormSeleccionarEgreso(props) {
    const {
        periodoL,
    } = props;

    const tipos = [
        {
            value: 'CHEQUES',
            label: 'CHEQUES'
        },
        {
            value: 'NOTAS DE DEBITO',
            label: 'NOTAS DE DEBITO'
        }
    ];

    const [id, setId] = useState("");
    const [idTE, setIdTE] = useState("");

    const handleChangeTE = e => {
        setIdTE(e.target.value);
    }
    
    const handleChange = e => {
        setId(e.target.value);
    }
    
    const [estadoModal, cambiarEstadoModal] = useState(true);
    let ruta = window.location.href;
    let id_emp = ruta.split('/');

    return (
        <div className='container'>
            <Modal
                estado={estadoModal}
                cambiarEstado={cambiarEstadoModal}
                titulo="Seleccionar Egreso"
                botonCerrar="false"
            >
                <div className="form-floating mb-3">
                    <select className="form-select" id="tipo" name="tipo"
                      value={idTE} onChange={handleChangeTE} autoFocus >
                      <option selected>Seleccionar...</option>
                      {tipos.map(
                        tipo => <option key={tipo.value} value={tipo.value}
                        >{tipo.label}
                        </option>)
                      }
                    </select>
                    <label className='form-label' htmlFor="mes">Egreso</label>
                </div>
                {periodoL && idTE != '' &&
                    <div className="form-floating mb-3">
                        <select className="form-select" id="periodo"
                            value={id} onChange={handleChange} >
                            <option selected>Seleccionar...</option>
                            {periodoL.map(mes =>
                                <option key={mes.value} value={mes.value}>{mes.label}</option>)
                            }

                        </select>
                        <label className='form-label' htmlfor="periodo">Periodo</label>
                    </div>
                }
                <br />
                <Contenido>
                    {periodoL.length > 0 && idTE === 'CHEQUES' &&
                        (id &&
                        <a
                            href={`/#/bancos/${id_emp[5]}/cheques/${id}`}
                            className='btn mr-2 mb-3 btn-primary'
                        >
                            Seleccionar
                        </a>
                        )
                    }
                    {periodoL.length > 0 && idTE === 'NOTAS DE DEBITO' &&
                        (id &&
                        <a
                            href={`/#/bancos/${id_emp[5]}/nota_debito/${id}`}
                            className='btn mr-2 mb-3 btn-primary'
                        >
                            Seleccionar
                        </a>
                        )
                        
                    }
                </Contenido>
            </Modal>
        </div>
    );

}
FormSeleccionarEgreso.propTypes = {
    periodoL: PropTypes.string.isRequired,
};

export default (FormSeleccionarEgreso);

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;